import React from "react";
import shape01 from "../../assets/img/banner/banner_shape01.png";
import shape02 from "../../assets/img/banner/banner_shape02.png";
import shape03 from "../../assets/img/banner/banner_shape03.png";
import fireIcon from "../../assets/img/icon/fire.png";
// import CountDownOne from "../CountDown/CountDownOne";
// import logo from "../../assets/img/logo/logo.png";
import { useLanguage } from "../../context/LanguageContext";
import StatsCardContainer from "../StatsCard/StatsCardContainer";

const Banner = (props) => {
  const { t } = useLanguage();

  return (
    <section className="banner-area banner-bg">

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="banner-content text-center">
              <h1 className="main-title text-info" style={{ marginBottom: "30px" }}>
                {t("banner.title")}
              </h1>
              <h2 className="subtitle" style={{ marginBottom: "30px", fontSize: "24px", fontWeight: "600" }}>
                {t("banner.subtitle")}
              </h2>
              <p
                className="description"
                style={{
                  marginBottom: "40px",
                  fontSize: "18px",
                  lineHeight: "1.6",
                }}
              >
                {t("banner.description")}
              </p>
              
              {/* Stats Cards */}
              <div style={{ marginBottom: "40px" }}>
                <StatsCardContainer />
              </div>
              
              <div className="banner-btn" style={{ marginBottom: "20px" }}>
                <a href="#contact" className="btn">
                  {t("banner.cta")}
                </a>
              </div>
            </div>
            {/* <div className="banner-progress-wrap">
              <ul>
                <li>Pre Sell</li>
                <li>Soft Cap</li>
                <li>Bonus</li>
              </ul>
              <div className="progress">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: "75%" }}
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
              <h4 className="title">
                65% target raised <span>1 ETH = $1000 = 3177.38 CIC</span>
              </h4>
            </div> */}
          </div>
        </div>
        {/* <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="banner-countdown-wrap text-center">
              <h2 className="title">ICO Will Start In..</h2>

              <CountDownOne />
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Banner;
